
const getAuthProviderConfigMapping = async () => {
    const response = await fetch(`${process.env.REACT_APP_EAV_ENDPOINT}/authProviders`, {
        method: 'GET'
    });
    if (!response) {
        return null;
    }
    return response.json();
}

const ExternalAuthValidator = {
    getAuthProviderConfigMapping
}

export default ExternalAuthValidator;